export default function Select({ value, onChange, children, error, disabled, ...props }) {
    return (
      <div className="select-wrapper">
        <select 
          value={value} 
          onChange={onChange} 
          disabled={disabled}
          {...props}
          className={`select ${error ? "select--error" : ""} ${disabled ? "select--disabled" : ""}`}
        >
          {children}
        </select>
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }